import type { DestroyRef, Signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import type { RealtimeConnectionState } from '@quipex/core/realtime';
import { combineLatest, EMPTY, switchMap, tap, timer } from 'rxjs';
import type { ActivityIdentity } from '../activity-journal';

export function watchActivityConnectionRecovery(input: {
    readonly destroyRef: DestroyRef;
    readonly identity: Signal<ActivityIdentity | null>;
    readonly connectionState: Signal<RealtimeConnectionState>;
    readonly markStale: () => void;
    readonly markStaleItemsUnavailable: () => void;
}): void {
    combineLatest([
        toObservable(input.identity),
        toObservable(input.connectionState),
    ])
        .pipe(
            switchMap(([identity, connectionState]) => {
                if (!identity) return EMPTY;

                if (connectionState !== 'connected') {
                    input.markStale();
                    return EMPTY;
                }

                return timer(15_000).pipe(tap(input.markStaleItemsUnavailable));
            }),
            takeUntilDestroyed(input.destroyRef)
        )
        .subscribe();
}
